// import logo from './logo.svg';
import './App.css';
import React from "react";
import * as d3 from "d3";
import * as Plot from "@observablehq/plot";
import stats from './data/stats.csv';
import twitters from './data/twitter2.csv';

import {Grid} from '@geist-ui/core'
import twitter_logo from './img/twitter_logo.png';


function App() {

  const ref = React.useRef()
  const ref2 = React.useRef()
  let [data,setData] = React.useState([])
  let [data2,setData2] = React.useState([])
  let [prog,setProg] = React.useState(101)
  let [index,setIndex] = React.useState(0)

////data load
  React.useEffect(() => {   
      d3.csv(stats).then(function(stats) {
        
        stats.forEach((d) => {
          d.date = d3.timeParse("%Y-%m-%d")(d.date);
          d.total = +d.total
          d.en = +d.en
          d.withoutua = +d.withoutua
          d.tags = +d.tags
          d.tagsen = +d.tagsen
        })
        // en,withoutua,tags,tagsen
        stats.sort((a,b)=>a.date-b.date);
        
        // console.log(d3.sum(stats,d=>d.tags))
        setData(stats)
      }).catch(function(err) {
          throw err;
      })
  }, []);

  
  ////data load
  React.useEffect(() => {   
    d3.csv(twitters).then(function(twitters) {
      
      twitters.forEach((d) => {
        d.date = d3.timeParse("%Y-%m-%d")(d.date);
        d.total = +d.total
        d.bad = +d.bad
      })
      // extractedts_,ua_sum,ru_sum,total_sum,date,per
      twitters.sort((a,b)=>a.date-b.date);
      // let total = twitters.filter(d=>d.date>d3.timeParse("%Y-%m-%d")("2022-05-01") && d.bad>2000) 

      // console.log(total)
      setData2(twitters)
    }).catch(function(err) {
        throw err;
    })
}, []);




  //////Chart 1
  React.useEffect(() => {
    if (data === undefined) return;
    
    const chart = Plot.plot({
      style:{
        fontSize:14,
        background:"#E1E8ED"
      },
      height:430,
      width:900,
      marginLeft:100,
      marginRight:40,
      marginTop:30,
      x:{tickFormat: d3.utcFormat("%y-%m")},
      y: {
        label:'Кількість твітів',
        
        grid: true,
        ticks:4,
        domain:[0,index==4&&prog==0?5500:index==4?prog*5500:index==5?5500:550000]
        // domain:[0,prog==0&&index==5?5500:index==5?prog*5500:index==6?5500:550000]
      },
      marks: [
        Plot.line(data,
                  Plot.windowY(
              {
                k: 7,
                reduce: "mean",
                x: "date", y: "total",
                opacity:index==0?1:.1,
                stroke:'#1DA1F2',
                strokeWidth:2
              }
          )
        ),
        Plot.line(data,
            Plot.windowY(
              {
                k: 7,
                reduce: "mean",
                x: "date", y: "en",
                opacity:index==1?1:.1,
                stroke:'#1DA1F2',
                strokeWidth:2
              }
          )
        ),
        Plot.line(data,
            Plot.windowY(
              {
                k: 7,
                reduce: "mean",
                x: "date", y: "withoutua",
                opacity:index==2?1:.1,
                stroke:'#1DA1F2',
                strokeWidth:2
              }
          )
        ),
        Plot.line(data,
            Plot.windowY(
              {
                k: 4,
                reduce: "mean",
                x: "date", y: "tags",
                opacity:index==3||index==4||index==5?1:.1,
                stroke:'#1DA1F2',
                strokeWidth:2
              }
          )
        ),
        Plot.text(["Твіти із тегами\n#IStandWithPutin\nта #ISstandWithRussia\n↓"], {
          x: new Date("2022-03-03"),
          textAnchor: "start",
          // frameAnchor: "bottom",
          y:50000,
          dx: 0,
          dy: 0,
          text: (d) => d,
          fontSize: 16,
          opacity:index==3||index==4||index==5?1:0
        })
      ]
    })

    ref.current.append(chart);
    return () => chart.remove();
  }, [data,index,prog]);






  //////Chart 2
  React.useEffect(() => {
    if (data === undefined) return;
    
    const chart2 = Plot.plot({
      style:{
        fontSize:14,
        background:"#E1E8ED"
      },
      height:430,
      width:900,
      marginLeft:100, 
      marginRight:40,
      marginTop:30,
      x:{tickFormat: d3.utcFormat("%y-%m")},
      y: {
        label:'Кількість твітів',
        grid: true,
        ticks:4,
        domain:[0,31000]
      },
      marks: [
        Plot.line(data2,
            Plot.windowY(
              {
                k: 4,
                reduce: "mean",
                x: "date", y: "bad",
                opacity:1,
                stroke:'#1DA1F2',
                strokeWidth:2
              }
          )
        ),
        Plot.dot([1], {
          r:20,
          x: new Date("2022-08-04"),
          y:10000,
          // stroke:'#1DA1F2',
          strokeDasharray: 5,
          opacity:index==7?1:0
        }),
        Plot.dot([1], {
          r:20,
          x: new Date("2022-08-07"),
          y:10000,
          // stroke:'#1DA1F2',
          strokeDasharray: 5,
          opacity:index==8?1:0
        }),
        Plot.dot([1], {
          r:20,
          x: new Date("2022-10-12"),
          y:2000,
          // stroke:'#1DA1F2',
          strokeDasharray: 5,
          opacity:index==9?1:0
        }),
        Plot.dot([1], {
          r:20,
          x: new Date("2022-11-15"),
          y:3500,
          // stroke:'#1DA1F2',
          strokeDasharray: 5,
          opacity:index==10?1:0
        }),
      ]
    })

    ref2.current.append(chart2);
    return () => chart2.remove();
  }, [data,index]);



////////enterView
React.useEffect(() => {
  enterView({
    selector: ".step",
    offset: 0.3,
    enter: el => {
      let index = +d3.select(el).attr("data-index");
      // d3.selectAll('.step').classed("is-active", (d, i) => i != month);
      setIndex(index)
      // console.log("enter",index);
    },
    progress: function(el, prog) {
      // if(prog<.01){prog=0.01}
      setProg(Math.round(100-prog*100))
      // console.log('progress',index,prog)
     },
    exit: (el) => {
      let index = +d3.select(el).attr("data-index");
      setIndex(index)
      // console.log("exit",index);       
      // el.classList.remove('entered');
    }
  });
}, []);




  console.log('APP:',index,prog)

  return (
    <div className="App">
     <section className="title">
      <h1 style={{color:"#1DA1F2"}}>Як Кремль програв війну за Твіттер</h1>
       <div className="subtitle">
       ТЕКСТИ проаналізували майже 60 млн твітів, щоб зрозуміти, як вели паралельну українсько-російську війну в одній з ключових соцмереж світу
      </div>
    </section>
    
  <section className="filler">  
      <p>
      Коли Росія напала на Україну, у соцмережах також почалася битва. ТЕКСТИ вже писали про спроби росіян підкорити мізки українців через <a href="https://texty.org.ua/projects/108016/telehram-okupaciya-yak-rosiya-vybudovuvala-mediamerezhu-vyjshlo-potomkinske-selo/?src=main">Телеграм</a>. Паралельна битва точилася й у Твіттері за увагу аудиторії з усього світу.
    </p>
    
    <p>
    Напад Росії на Україну з перших днів викликав справжній твіттер-шторм. За подіями в Україні стежив увесь світ, очікуючи на напад, — саме так, як попереджали американські офіційні особи. Відтоді й станом на 4 грудня було написано майже 60 млн твітів, які так чи так стосуються подій в Україні (детальніше див. методологію). Ми їх проаналізували.
    </p>
  </section>

   



    <section id="scrolly-overlay" style={{background:"#E1E8ED"}}>
      <div className="scrolly" >
        <figure className="sticky" 
        
        >
          <Grid.Container gap={0} justify="center">
            <Grid>
              <div id="chart" ref={ref}></div>
            </Grid>
          </Grid.Container>
        </figure>

        <article>
          <div className="step" data-width="10%" data-index="0">
            <p>
            Синя лінія — денна кількість твітів (злагоджена за кожні сім днів), пов'язаних з Україною, починаючи від 24 лютого 2022 року. Пік на початку й очікуваний поступовий спад.

            </p>
          </div>
          <div className="step" data-width="90%" data-index="1">
            <p>
            Близько 65% твітів англомовні. Значна частка неангломовної аудиторії — з країн Азії, насамперед з Індії.

            </p>
          </div>
          <div className="step" data-width="50%" data-index="2">
            <p>
            Якщо прибрати твіти, написані з України, статистика майже не зміниться: на загальному тлі їх небагато. Ця платформа — особливо тоді — була не надто популярною в нашій країні. Хоча тут також може бути істотна частка українців, які могли писати англомовні твіти з ЄС.

            </p>
          </div>
          <div className="step" data-width="50%" data-index="3">
            <p>
            А це — проросійська твіттер-компанія. Відправною точкою для її ідентифікації стали дані, які ще на початку березня зібрала британська аналітична компанія Casm Technology з 7756 підозрілих акаунтів у Твіттері. Усі вони використовували хештеги #IStandWithPutin або #ISstandWithRussia. Як установили аналітики, приблизно половину твітів з такими тегами писали підозрілі акаунти — вочевидь, проплачені Кремлем. Як, наприклад, ось такий "стандартний" твіт без тексту, лише з тегами.

            <div className="twitter">
            <img width='7%' src={twitter_logo}></img>
            '#USA #StateSept the #Ministry of #Disinformation #IStandWithPutin #Z #V https://t.co/SO1T3gYaOo'
            </div>
            </p>
          </div>

        <div className="step" data-width="50%" data-index="4">
          <p>
            
          У будь-якому разі, на загальному тлі їх було дуже мало: лише 30 тис. Ось вони детальніше.

            </p>
          </div>

          <div className="step" data-width="50%" data-index="5">
            <p>
            Схоже, що після різкого старту в березні від квітня компанія захлинулась і замовкла.

            </p>
          </div>

        </article>
      </div>
    </section>



    <section className="filler">  
    <p>
    Найімовірніше, її діяльність припинив сам Твіттер: більшість твітів і половину акаунтів цієї групи було видалено в рамках політики боротьби з дезінформацією.

    </p>
      <p>
      Росіяни зазнали поразки й закинули ідею підкорити твіттер чи лише змінили тактику?
      </p>

      <p>
      Наприклад, замість явної підтримки Росії, почали писати про проблеми в західних країнах через війну, голод у країнах Африки тощо або використовувати менш очевидно керовані з Кремля твіттер-шторми.

      </p>
      <p>
      Щоб перевірити це й генералізувати проросійську спільноту, ми побудували модель, яка визначає проросійські твіти. Вона навчалася на твітах з хештегами #IStandWithPutin та ISstandWithRussia, а далі помічала аналогічні твіти, навіть якщо в них були інші теги чи акценти (детальніше див. у розділі методологія).

      </p>

<p>
Так нам вдалося ідентифікувати близько 1,5 млн твітів, які є або відверто проросійськими, або просто підважують позиції України. Наприклад, наш алгоритм до цієї групи відніс також дуже велику й потужна мережу твітів, пов'язану з внутрішньою американською політикою. Фінансову допомогу Україні прихильники Республіканської партії часто використовували у прив'язці до протистояння з адміністрацією Байдена: для них питання України було лише політичним інструментом. Проте все одно вигідним Кремлю.
 
</p>
    </section>

 

    <section id="scrolly-overlay" style={{background:"#E1E8ED"}}>
      <div className="scrolly">
        <figure className="sticky" 
        // style={{border:"1px solid red"}}
        >
          <Grid.Container gap={2} justify="center">
            <Grid>
              <div id="chart2" ref={ref2}></div>
            </Grid>
          </Grid.Container>
        </figure>

        <article>
          <div className="step" data-width="10%" data-index="6">
            <p>
            Проте навіть з умовно нейтральними твітами наша модель показує, що це лише 2,5% від усіх твітів і 4% — від англомовних твітів, написаних не з України. Розгляньмо їх детальніше.

            </p>


          </div>
          <div className="step" data-width="90%" data-index="7">
            <p>
            Досить висока активність трималася як мінімум до середини серпня. Стрибок у період між 2 та 7 серпня пов'язаний з ескалацією в Секторі Газа, яку твітер-користувачі так само порівнювали чи асоціювали з війною в Україні та представляли як жертву нападу. Переважно це були місцеві / локальні користувачі. Вони апелювати до того, що Заходу не байдуже на Україну, яку він підтримує, але байдуже на Газа (саме тому ці твіти наша модель ідентифікувала як проросійські, хоча це, мабуть, не дуже доречна характеристика. Імовірніше, тут ідеться про боротьбу за увагу західної аудиторії). Цю хвилю твітів, до прикладу, описує ось такий гугл-переклад: 
            <div className="twitter">
              <img width='7%' src={twitter_logo}></img>
              'Це не Україна! Це #Сектор Газа #Gaza Strip вчора!💔\n\n#GazaUnderAttack\n#غزة_تحت_القصف\n#غزه_تقاوم\n https://t.co/GczF5K593T',
            </div>
            </p>
          </div>
          <div className="step" data-width="90%" data-index="8">
            <p>
            Також на цей час припав візит спікерки Палати представників США Ненсі Пелосі на Тайвань. Цей візит часто супроводжували хештегами зі згадуванням України — мабуть, проводили паралелі між нами й островом, що перебуває під ризиком потенційного нападу з боку Китаю.

            </p>
          </div>
          <div className="step" data-width="50%" data-index="9">
            <p>
            Ще один з недавніх піків активності проросійських хештегів був у першій декаді жовтня — після підриву Nord Stream і перших масових ракетних атак росіян на енергетичну інфраструктуру України. Твіти, які наша модель ідентифікувала як проросійські, не були явною підтримкою однієї зі сторін війни. Проте вони були, хоч як дивно це звучить, за "мир”. Якщо коротко, то українській владі треба позбавити Україну страждань (хто в них винен і як це зробити — дописувачам байдуже). Ці твіти часто супроводжував тег #ZelenskyWarCriminal. Ось гугл-переклад одного з них:
            <div className="twitter">
              <img width='7%' src={twitter_logo}></img>
              "@aixo91 @CriolloCalabozo @SpiritofHo звичайно ти гавкаєш не туди. Мені байдуже, виграє чи програє сторона. Дбайте лише про те, щоб якнайшвидше зупинити бомби. Годування #України зброєю із Заходу не означає цього. байдуже, якщо Україна втратить Крим чи Донбас, якщо люди перестануть вмирати. Я думаю, що США є підбурювачем і повинні займатися своїми справами"
            </div>
            </p>
          </div>
          
          <div className="step" data-width="50%" data-index="10">
            <p>
            А в листопаді був стрибок через те, що наша модель визначила ключовим тег #WWIII (третя світова війна), під яким — імовірно, щиро — на Заході панікували про потенційний вступ НАТО у війну після падіння ракети в Польщі.
         
            </p>
          </div>

        </article>
      </div>
    </section>




    <section className="filler">  

    <p>
    Якщо початковою компанією, очевидно, керували з Кремля, то далі негативні для України твіти були пов'язані з різними місцевими чи глобальними подіями. Частину тегів про зростання цін і непередбачуваність для жителів західних країн, про "корупцію" Байдена та демократів, які "безконтрольно" вливають гроші в Україну, тощо — наша модель так само відносила до проросійських. У будь-якому разі, частка тих, хто співчуває Росії (або не розуміє, навіщо допомагати Україні), якщо рахувати від кількості твітів, була на мізерному рівні.
    </p>

      <p>
      Твіттер-шторм Кремля виявився "бурею у склянці". Битву за англомовну аудиторію росіяни поки що програють. Проте є ризик, що політика нового власника Твіттера Ілона Маска може призвести до зростання кількості проросійських твітів, хоча поки що цього не помітно (Маск контролює компанію від 1 листопада). Новий власник здобув Твіттер менш ніж три тижні тому, але вже <a hreg="https://www.latimes.com/business/story/2022-11-18/twitter-risks-fraying-as-engineers-exit-over-musk-upheaval">звільнив</a> половину штатного персоналу зі 7500 співробітників і незліченну кількість підрядників, які відповідали за модерацію контенту й інші важливі функції. Як, наприклад, припинення березневої компанії дезінформаторів Путіна.
    </p>  

  
    _______________
    <small>

    <p><b>Методологія:</b></p>
    <p>Дані доступні за цим посиланням на сайті <a href="https://www.kaggle.com/datasets/bwandowando/ukraine-russian-crisis-twitter-dataset-1-2-m-rows">Kaggle</a>. Це майже 60 млн твітів, починаючи від 24 лютого й до сьогоднішнього дня (аналіз здійснено на твітах до 4 грудня включно).
</p> 
    <p>Як відправну точку для ідентифікації проросійських твітів було взято твіти з хештегами #IStandWithPutin або #ISstandWithRussia, які ще на початку березня <a href='https://www.economist.com/graphic-detail/2022/05/14/russia-is-swaying-twitter-users-outside-the-west-to-its-side?utm_medium=social-media.content.np&utm_source=twitter&utm_campaign=editorial-social&utm_content=discovery.content&%3Ffsrc%3Dscn%2F=tw%2Fdc'>встановила</a> компанія Casm Technology як підозрілі акаунти (половину з них було видалено в тому-таки березні).
</p> 

    <p>Разом з ними часто використовують такі теги, як #IStandWithPutin, #NaziUkraine, #ZelenskyWarCriminal, #Istandwithrussia, #ZelenskyWarCriminal, #UkraineTerrorState, #StopNaziUkraine, #StopNATO. Усі твіти з ними стали вибіркою проросійських твітів. Разом близько 10 тис. твітів.</p>

<p>Як проукраїнські твіти ми вибрали твіти з такими тегами: #RussiaIsATerroristState, #StandWithUkraine, #PutinWarCriminal, #StopRussiaNOW, #StopRussia, #StopPutin, #CrimeaIsUkraine, #FreeUkraine, #UkraineUnderAttaсk. Випадково було зібрано близько 50 тис. твітів.
</p>

<p>Теги, за якими робили вибірку, з датасету було видалено, щоб запобігти перенавчанню моделі й дати їй змогу максимально генералізувати патерни. Після навчання акуратність моделі становила 96% (у випадку ідентифікації проросійських твітів — 87%).
</p>

<p>У результаті модель ідентифікувала близько 1,5 млн твітів (близько 4% від загальної кількості англомовних).

    </p>

<p>Ось приклад випадково вибраних твітів, які модель позначила як проросійські:
</p>

<div style={{color:"grey",fontStyle: "italic"}}>
    '@Amb_Ulyanov You should better close your Twitter Answer permissions, you are dealing with a western pro #Azov Trollarmy.',<br></br>
 '@mtracey I think @NATO has served its purpose &amp; being transformed for some other goal\n\nBut if we\'re going to stay a part of #NATO it should be treated like insurance. If you don\'t make your "premiums" (2%of GDP agreed apon) you don\'t get covered in time of emergency https://t.co/uqeKVQd9gj',<br></br>
 '@BuzzPatterson What? You worship #Putin? I see you really support democracy — not.',
 'UN secretary general visits Ukraine but he never visited Kashmir,Palestine, Iraq, Syria, Yemen or Afghanistan for that matter. Is it the US or the skin colour matters?\n\n#Ukraine',<br></br>
 '#biden is put in sunglasses to hide is dead eyes. FACT #Democrats #DementiaJoe #dementiacare',<br></br>
 '#Ukraine #Russia #Zaporizhzhia #ZaporizhzhiaNPP \n\nThe news about #Zaporizhye are a paradigm of disinformation and propaganda characteristic of this war.\nLies are fired like missiles, and they fly faster than the light of truth. https://t.co/OzmuRgYaJx',<br></br>
 'US Treasury official to visit India amid Ukraine tensions\n\n#UnitedStates #India #Ukraine #Russia \nhttps://t.co/zTxz6DNuMe',
 </div>

    <p>Зазначимо, що ми не ставили за ціль зробити ідеально точну модель, а намагалися зрозуміти масштаби проросійської компанії в соцмережі.
</p>

    </small>

    </section>
 

    </div>
  );
}



export default App;
